import { Link as ReactRouterLink } from "react-router-dom";
import styled from "styled-components";

export const Link = styled(ReactRouterLink)`
  color: ${({ theme }) => theme.colors.darkblue};
  display: flex;
  flex-direction: row;
  font-weight: bold;
  text-decoration: none;

  :hover {
    opacity: 0.7;
    text-decoration: underline;
  }
`;
